import { text } from '#contract'
import { useT } from '../../i18n/index.ts'
import { FilesIcon } from '../icons/app-icons.tsx'
import { AppEmptyState } from './app-empty-state.tsx'
import styles from './apps.module.css'

/** Files (desktop only): the recent files, none yet. */
export function FilesApp() {
  const t = useT()
  return (
    <div class={styles.app}>
      <header class={[styles.header, styles.plain].join(' ')}>
        <h1 class={styles.title}>{t(text('os.app.files.recents'))}</h1>
      </header>
      <AppEmptyState id="files" icon={FilesIcon} />
    </div>
  )
}
